import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpService} from "./http.service";

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {
  url: string;

  constructor(private http: HttpClient,
              private httpService: HttpService) {
    this.url = this.httpService.getApiUrl() + '/newsletter'
  }

  addNewsletter(email: string): Observable<void> {
    return this.http.post<void>(this.url, email);
  }
}
